import { Navigate, useParams, useNavigate } from "react-router-dom";
import { useAppStore } from "@/store/use-store";
import { useEffect } from "react";
import { isRoleAllowed } from "@/lib/roles";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

/**
 * Middleware de protección de rutas por rol y tenant.
 */
export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { userRole } = useAppStore();
  const { tenant: urlTenant } = useParams();
  const navigate = useNavigate();

  // Obtener usuario de la sesión
  const storedUserStr = typeof window !== "undefined" ? sessionStorage.getItem("user") : null;
  const storedUser = storedUserStr ? JSON.parse(storedUserStr) : {};

  // Normalizar el rol y el tenant autorizado
  const currentRole = (userRole || storedUser.rol || "").toLowerCase().trim();
  const authorizedTenant = storedUser.slug || "";

  useEffect(() => {
    // Validación de Tenant
    if (urlTenant && authorizedTenant && urlTenant !== authorizedTenant) {
      navigate("/forbidden", { replace: true });
    }
  }, [urlTenant, authorizedTenant, navigate]);

  // 1. Si no hay sesión, al login
  if (!currentRole) {
    return <Navigate to="/" replace />;
  }

  // 2. Validación de Tenant (Bloqueo preventivo en render)
  if (urlTenant && authorizedTenant && urlTenant !== authorizedTenant) {
    return null; // No renderizamos nada mientras el useEffect redirige
  }

  // 3. Si hay roles específicos permitidos y el usuario no lo tiene, al 403
  if (allowedRoles && !isRoleAllowed(currentRole, allowedRoles)) {
    return <Navigate to="/forbidden" replace />;
  }

  return <>{children}</>;
}
